const _get = require('lodash.get');

export function coalesce(row: Object, path: String): string {
  return _get(row, path, 'Não informado');
}
